// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2BLRB","choiceBoxes":"toolbarselects_choiceBoxes__2tpAJ","simpleField":"toolbarselects_simpleField__1h3j1"};